<template>
    <div class="MessageContent">
        <v-spacer v-if="!isUser"></v-spacer>
        <div class="message-text-container" style="background: #fff; padding: 6px">
            <table>
                <tr>
                    <td>{{$t('latitude')}}</td>
                    <td style="font-weight: bold; padding-left: 5px">{{location.lat}}</td>
                </tr>
                <tr>
                    <td>{{$t('longitude')}}</td>
                    <td style="font-weight: bold; padding-left: 5px">{{location.long}}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import MessageContent from "components/message-box/content/MessageContent";

export default {
    name: "MessageContentUserLocation",
    extends: MessageContent,
    computed: {
        location() {
            return JSON.parse(this.content.text)
        }
    }
}
</script>
